import React, { useRef, useEffect, useState } from 'react';
import './ChatView.css';
import Message from '../Message/Message';
import 'intersection-observer';
import Spinner from '../Spinner/Spinner';
import { useSelector } from 'react-redux';
import { getUserId } from '../../store/User/UserSelectors';
import {
  getMessages,
  isMessagesLoading,
} from '../../store/Messages/MessagesSelectors';
import { getTenantConfig } from '../../store/Config/configSelectors';

const ChatView = ({ setHome, sendMessage }) => {
  const messagesEndRef = useRef(null);
  const initialPromptSent = useRef(false);

  const userId = useSelector(getUserId);
  const messages = useSelector(getMessages);
  const isLoading = useSelector(isMessagesLoading);
  const { messageFlagEnabled, initialPrompt } = useSelector(getTenantConfig);

  const [shouldSendInitialPrompt, setShouldSendInitialPrompt] = useState(false);

  // Automatically scroll to bottom when messages change
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages.length]);

  useEffect(() => {
    if (
      !initialPromptSent.current &&
      initialPrompt &&
      messages.length === 0 &&
      shouldSendInitialPrompt
    ) {
      sendMessage({ type: 'user', message: initialPrompt });
      initialPromptSent.current = true;
    }
  }, [initialPrompt, shouldSendInitialPrompt]);

  useEffect(() => {
    // Listen for postMessage from Squarespace parent
    const handleMessage = event => {
      if (event.data === 'quizOpened') {
        console.log('Quiz opened inside iframe...');
        setShouldSendInitialPrompt(true); // Mark as ready to show
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <div className="Chat-Scroll-Wrapper">
      {messages?.map((message, index) => (
        <Message
          key={index}
          message={message}
          user={userId}
          messageFlagEnabled={messageFlagEnabled}
        />
      ))}
      <div ref={messagesEndRef} />
      {isLoading && <Spinner />}
    </div>
  );
};

export default ChatView;
